import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { Level } from '@ascschool/model/category/level.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { DepartmentOfEducationAndTraining } from '@ascschool/model/organization/department-of-educatio-and-training.model';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ManageAccountBoService } from '@ascschool/services/user/manageaccount-bo.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload'; 
import { PopUpDonViQuanLyComponent } from '../../thong-tin-don-vi/don-vi-quan-ly/pop-up-don-vi-quan-ly/pop-up-don-vi-quan-ly.component';
import { XemDonViQuanLyComponent } from '../../thong-tin-don-vi/don-vi-quan-ly/xem-don-vi-quan-ly/xem-don-vi-quan-ly.component';
import { CapNhatMatKhauComponent } from '../cap-nhat-mat-khau/cap-nhat-mat-khau.component';
import { ManageAccountSoService } from '@ascschool/services/user/manageaccount-so.service';
@Component({
  selector: 'app-quan-ly-tk-don-vi-quan-ly',
  templateUrl: './quan-ly-tk-don-vi-quan-ly.component.html',
  styleUrls: ['./quan-ly-tk-don-vi-quan-ly.component.scss']
})
export class QuanLyTkDonViQuanLyComponent implements OnInit, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  heightModal: string;
  widthModal: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    private authQuery: AuthQuery,
    private manageaccountBoService: ManageAccountSoService,
    public utilService: UtilsService
  ) {}
  get breadcrumbs(): string[] {
    return ['Quản trị hệ thống'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];  

  searchAdvanced = true;
  checkedAll: boolean = false;
  commonFilter: CommonFilter = new CommonFilter();
  listSo: DepartmentOfEducationAndTraining[];
  listDVQLSelected: number[] = [];
  searchNhomNguoiDungCtrl: FormControl;
  
  
  searchTerm: string = '';
  pageIndex: number = 1;
  categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  listData: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;

  sortNameFn = (a: Level, b: Level) => a.levelName.localeCompare(b.levelName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.commonFilter.AccountType = 1;
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    this.loading = true;
    this.checkedAll = false;
    this.manageaccountBoService.getUserEducationAndTrainingOrSchool(this.commonFilter).subscribe((response: any) => {
      this.Total = response.rowCount;
      this.firstRowOnPage = response.firstRowOnPage;
      this.listSo = response.results ? response.results : [];
      this.loading = false;
      this.listSo.map(x => x.checked = false);
      this.listDVQLSelected = [];
    }, (err: any) => {
      this.listSo = [];
      this.listDVQLSelected = [];
      this.loading = false;
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
     
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void {}
  //popup
  edit(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup= 'Cập nhật thông tin tài khoản đơn vị quản lý cấp Tỉnh/thành phố';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpDonViQuanLyComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
      },
      nzComponentParams: {
        dataTransmission: item.educationAndTrainingId
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      

      if (results) {
        this.reload();
      }
    });
  }

  viewHoSo(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup= 'Xem - thông tin tài khoản đơn vị cấp tỉnh/thành phố';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: XemDonViQuanLyComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
      },
      nzComponentParams: {
        dataTransmission: item.educationAndTrainingId
      },
      nzWidth: 1300
    }); 
    this.dialogRef.afterClose.subscribe((results) => { 

      if (results) {
        this.reload();
      }
    });
  }

  capNhatMatKhau(): void {
    this.isResizdePopup = false;
    this.titlePopup= 'Cập nhật mật khẩu';
    this.heightModal = 'auto';
    this.widthModal = 700 + 'px';
    this.setOfCheckedId.forEach(item => {
      this.listDVQLSelected.push(item);
    });
    if (this.listDVQLSelected.length > 0) {
      this.dialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: CapNhatMatKhauComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: {
          overflow: 'auto'
        },
        nzComponentParams: { 
          listId: this.listDVQLSelected
        },
        nzWidth: 700
      }); 
      this.dialogRef.afterClose.subscribe((results) => {  
        if (results) {
          this.reload();
        }
      });
    } else {
      this.msg.warning('Vui lòng chọn tài khoản để cập nhật!');
    } 
  }
  
  deleteMulti(): void {
    this.listDVQLSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listDVQLSelected.push(item);
    });
    if (this.listDVQLSelected.length > 0) {
    const dialogRef = this.modalService.create({
      nzTitle: 'Xóa tài khoản đơn vị cấp tỉnh/thành phố',
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: 'tài khoản đã chọn'
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
    });
    dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.manageaccountBoService.deleteMulti(this.listDVQLSelected).subscribe((res: any) => {
          this.msg.success('Cập nhật thông tin ' + res.message);
          this.reload();
        });
      }
    });
  } else {
    this.msg.warning('Bạn chưa chọn dữ liệu cần xóa');
  }
  }
  clear() {
    delete this.commonFilter.EducationAndTrainingCode;
    delete this.commonFilter.EducationAndTrainingName;
    delete this.commonFilter.Director;
    this.reload();
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  exportExcel() { 
    // document.getElementById('btnvF').click(); 
   
      this.manageaccountBoService.exportExcel(this.commonFilter).subscribe((data) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'DanhSachTaiKhoanDonViQuanLy.xlsx';
        link.click();
      });  
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height = this.heightModal;
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { 
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
}
